module.exports = __webpack_public_path__ + "static/media/Tracking-hero.72afe9a2.png";